import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entry } from 'contentful';
import { LocalizationService } from '../../services/localization/localization.service';
import { MetaService } from '../../services/meta/meta.service';
import { StoreService } from '../../services/store/store.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public content: Entry<any>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localizationService: LocalizationService,
    private storeService: StoreService,
    meta: MetaService
  ) {
    this.content = route.snapshot.data.content;
    if (this.content && this.content.fields.seo) {
      meta.updateMetaTags(this.content.fields.seo);
    }
  }

  ngOnInit() {}

  nextPage() {
    const returnUrl = this.storeService.returnUrl.getValue();
    if (returnUrl) {
      this.storeService.returnUrl.next('');
      this.router.navigate([returnUrl]);
    } else {
      this.storeService.returnUrl.next('');
      this.localizationService.navigate(['profile']);
    }
  }
}
